const CHAR_PIXEL_WIDTH = 8;
const SIDES_PADDING = 30;
const ICON_PIXEL_WIDTH = 32;

/**
 * Calculate the minimum width for a table column based on header name length and icons
 * Formula: (headerName.length * 15px) + 30px (sides padding) + (32px * number of icons)
 */
export const calculateColumnMinWidth = (
  headerName: string,
  options: {
    hasHeaderIcon?: boolean;
    isSearchable?: boolean;
    hasFilterOptions?: boolean;
    isSortable?: boolean;
    hasMenuOptions?: boolean;
  }
): number => {
  const baseWidth = headerName.length * CHAR_PIXEL_WIDTH;
  const sidesPadding = SIDES_PADDING;

  // Count icons
  let iconCount = 0;
  if (options.hasHeaderIcon) iconCount++;
  if (options.isSearchable) iconCount++;
  if (options.hasFilterOptions) iconCount++;
  if (options.isSortable) iconCount++;
  if (options.hasMenuOptions) iconCount++;

  const iconsWidth = iconCount * ICON_PIXEL_WIDTH;

  return baseWidth + sidesPadding + iconsWidth;
};
